function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open'),
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget
        .closest('details, details-custom')
        .hasAttribute('open'),
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*',
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');
    this.startingValue = this.input.value;
    this.input.dataset.starting = this.startingValue;
    this.min = this.input.min;
    this.max = this.input.max;

    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this)),
    );

    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault(); // Prevent the default "Enter" behavior
        event.stopImmediatePropagation(); // Prevent other event listeners from receiving the event

        //remove focus from input
        this.input.blur();
      }
    });

    this.input.addEventListener('input', (event) => {
      this.input.dataset.starting = this.startingValue;
    });

    this.input.addEventListener('change', (event) => {
      var is_valid = this.input.checkValidity();

      if (!is_valid) {
        //not valid
        this.input.reportValidity();

        var min = parseInt(this.min);
        var max = parseInt(this.max);
        var value = parseInt(this.input.value);

        if (value < min) this.input.value = min;

        if (value > max) this.input.value = max;
      }
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json', method = 'POST') {
  return {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

// https://gist.github.com/stewartknapman/8d8733ea58d2314c373e94114472d44c?permalink_comment_id=3141993
Shopify.money_format = '${{amount}}';
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`,
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary'),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button'),
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');

    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    const summaryElements = this.mainDetailsToggle.querySelectorAll('summary');
    summaryElements.forEach((summary) =>
      summary.setAttribute('aria-expanded', false),
    );

    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary'),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('header-group');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom',
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`,
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false),
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);

    //check for yotpo and initialise
    var yotpo_item = this.querySelector("[class*='yotpo']");
    if (
      yotpo_item &&
      typeof yotpoWidgetsContainer != 'undefined' &&
      typeof yotpoWidgetsContainer?.initWidgets == 'function'
    ) {
      yotpoWidgetsContainer.initWidgets();
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide(e) {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class WrappingPopup extends ModalDialog {
  constructor() {
    super();

    this.form = this.querySelector('#wrapping-popup-form');

    if (!this.form) return;

    this.form.addEventListener('submit', this.handleFormSubmit.bind(this));
  }

  show(opener) {
    var wrapping_toggle = opener.closest('wrapping-toggle');
    var cart_drawer = document.querySelector('cart-drawer');

    if (!wrapping_toggle || !cart_drawer) return;

    cart_drawer.close();

    var current_value = wrapping_toggle.dataset.active ?? null;

    if (current_value) {
      //find the toggle and check

      var selected_option = this.querySelector(
        `#wrapping-option--${current_value}`,
      );
      if (!selected_option) return;
      selected_option.checked = true;
      selected_option.dispatchEvent(new Event('change', { bubbles: true })); //trigger event for alpine
    } else {
      //uncheck everything
      var all_options = this.querySelectorAll('input');
      Array.from(all_options).forEach((option) => option.checked == false);
    }

    //add main product id to form for adding with gc
    var main_prod_el = opener.closest('.product');
    var main_variant_el = this.querySelector('input[name="items[0][id]"]');

    if (main_prod_el && main_variant_el) {
      //get id input
      let id_el = main_prod_el.querySelector(
        'input[name="id"], input[name*="items[id]"]',
      );

      if (id_el) {
        let main_variant_id = id_el.value;

        //set main variant id
        main_variant_el.value = main_variant_id;
      }
    }

    super.show(opener);
  }

  async handleFormSubmit(e) {
    e.preventDefault();

    let submitter = e.submitter;
    let data = new FormData(this.form);

    let submission_type = submitter.dataset.type;

    let option = data.get('wrapping-option');

    if (!option || !this.openedBy) return;

    var card_added = false;

    if (submission_type == 'gc') {
      //add gift card product
      var product_form = this.querySelector('product-form');

      const fakeEvt = {
        target: product_form.querySelector('form'),
        preventDefault: () => {
          console.log('Navigation prevented');
        },
        stopPropagation: () => {},
      };

      await product_form.onSubmitHandler(fakeEvt);

      card_added = true;
    }

    this.openedBy.dispatchEvent(
      new CustomEvent('wrappingChosen', {
        detail: {
          wrappingOption: option,
          cardAdded: card_added,
        },
      }),
    );

    setTimeout(() => {
      //reset
      window.dispatchEvent(
        new CustomEvent('set-step', {
          detail: {
            step: 0,
          },
        }),
      );
    }, 400); //after animation ends. not amazing but will do
  }
}
customElements.define('wrapping-popup', WrappingPopup);

class HashPopup extends ModalDialog {
  constructor() {
    super();
    this.hash = this.getAttribute('hash-target');

    window.addEventListener('hashchange', (e) => {
      if (e.newURL.includes(this.hash)) {
        this.show();
      }
    });
  }

  connectedCallback() {
    super.connectedCallback();
    if (window.location.hash.includes(this.hash)) {
      this.show();
    }
  }
}

customElements.define('hash-popup', HashPopup);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');

    if (!this.button) return;
    this.button.addEventListener('click', () => {
      if (this.hasAttribute('data-share') && navigator.share) {
        //share is available and is share modal
        var title = this.dataset.title;
        var desc = this.dataset.desc;
        var url = this.dataset.url;

        return navigator
          .share({
            title: title,
            text: desc,
            url: url,
          })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error));
      }

      this.modal = document.querySelector(this.getAttribute('data-modal'));
      if (this.modal) this.modal.show(this.button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class WrappingToggle extends ModalOpener {
  constructor() {
    super();
    this.type = this.dataset.type;

    if (!this.button || !this.type) return;

    this.button.addEventListener(
      'wrappingChosen',
      this.handleWrappingChoice.bind(this),
    );
  }

  handleWrappingChoice(e) {
    var wrapping = e.detail.wrappingOption;
    var card_added = e.detail.cardAdded;

    if (!wrapping) return;

    if (this.type == 'add') {
      var product_form_id = this.dataset.productForm;

      // needs to consider sticky atc
      var product_forms = document.querySelectorAll(`form#${product_form_id}`);

      if (!product_forms[0]) return;

      Array.from(product_forms).forEach((product_form) => {
        let wrapping_property_el = product_form.querySelector(
          "input[name='properties[_wrapping]']",
        );

        if (!wrapping_property_el) {
          //no wrapping input so create one
          wrapping_property_el = document.createElement('input');
          wrapping_property_el.type = 'hidden';
          wrapping_property_el.name = 'properties[_wrapping]';
          product_form.appendChild(wrapping_property_el);
        }

        wrapping_property_el.value = wrapping;
      });
    } else if (this.type == 'edit') {
      //cart item
      var cart =
        document.querySelector('cart-items') ??
        document.querySelector('cart-drawer-items');
      var cart_drawer = document.querySelector('cart-drawer');

      if (!cart || !cart_drawer) return;

      var quantity = this.dataset.itemQuantity;
      var index = this.dataset.itemIndex;
      var properties = { _wrapping: wrapping };
      cart.updateQuantity(index, quantity, null, null, properties);
      cart_drawer.open();
    }

    this.modal.hide();
    this.dataset.active = wrapping;

    if (card_added) {
      var atc_callout = this.querySelector('.atc-callout');

      if (!atc_callout) return;

      atc_callout.classList.add('active');

      setTimeout(() => {
        atc_callout.classList.remove('active');
      }, 2500);
    }
  }
}
customElements.define('wrapping-toggle', WrappingToggle);

class InsideListener extends HTMLElement {
  constructor() {
    super();
    //inside only has a js event so need to liten to a hashchange
    this.inside_hash = this.getAttribute('hash') ?? 'support-chat';
  }
  connectedCallback() {
    this.checkAndOpenInside(window.location.hash);

    window.addEventListener('hashchange', (e) => {
      this.checkAndOpenInside(e.newURL);
    });
  }
  checkAndOpenInside(current_url) {
    if (
      current_url.newURL?.includes(this.inside_hash) &&
      typeof insideFrontInterface?.openChatPane() !== 'undefined'
    ) {
      insideFrontInterface.openChatPane();
    }
  }
}

customElements.define('inside-listener', InsideListener);

class KHubListener extends InsideListener {
  constructor() {
    super();
    this.account_url = this.getAttribute('account-url');
  }
  connectedCallback() {
    super.connectedCallback();
  }
  checkAndOpenInside(current_url) {
    if (current_url.includes(this.inside_hash)) {
      //wait 2 seconds to see if k-hub loads
      setTimeout(() => {
        if (!document.querySelector('#k-hub')) {
          window.location = this.account_url;
        }
      }, 5000);
    }
  }
}

customElements.define('khub-listener', KHubListener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    if ('autoplay' in this.dataset) {
      this.setupIntersectionObserver();
    }

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    if ('pauseAll' in this.dataset) {
      //default behavior - dont pause all other vids
      window.pauseAllMedia();
    }
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      var media = content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe'),
      );

      media.play(); //play for ios

      media.addEventListener('canplaythrough', () => {
        //video
        media.play(); //play for ios

        const playing_event = new Event('playing');
        this.dispatchEvent(playing_event);
      });

      if (focus) deferredElement.focus();
    }
  }

  setupIntersectionObserver() {
    if ('IntersectionObserver' in window) {
      var lazyMediaObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((media) => {
          if (media.isIntersecting) {
            this.loadContent(false);
            lazyMediaObserver.unobserve(this);
          }
        });
      });
      //TODO - product thumbnail on mobile, no autoplay
      lazyMediaObserver.observe(this);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.initialized = false;
    this.observer = null;
    this.resizeObserver = null;
  }

  connectedCallback() {
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              console.log('firing slider observer', this);
              this.init();
              observer.unobserve(this);
            }
          });
        },
        { rootMargin: '0px 0px 200px 0px' },
      );
      this.observer.observe(this);
    } else {
      this.init();
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  init() {
    if (this.initialized) return;

    const id = this.dataset.sliderId;

    this.slider = this.querySelector(`[id^="Slider-"]`);
    this.sliderItems = this.querySelectorAll(`[id^="Slide-"]`);
    this.sliderControlWrapper = this.querySelector('.slider-buttons');

    if (!this.slider) {
      return;
    }

    if (id && id != '') {
      //slider within a slider
      this.slider = this.querySelector(`[id^="Slider-${id}"]`);
      this.sliderItems = this.querySelectorAll(`[id^="Slide-${id}"]`);
      this.sliderControlWrapper = this.querySelector(`#slider-buttons--${id}`);
    }

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.sliderControlWrapper?.querySelector(
      'button[name="previous"]',
    );
    this.nextButton = this.sliderControlWrapper?.querySelector(
      'button[name="next"]',
    );
    this.sliderFirstItemNode = this.slider.querySelector(this.getSlideClass());

    if (!this.slider || !this.nextButton) {
      return;
    }
    if (this.sliderControlWrapper) {
      this.sliderControlLinksArray = Array.from(
        this.sliderControlWrapper.querySelectorAll('.slider-counter__link'),
      );
      this.sliderControlLinksArray.forEach((link) =>
        link.addEventListener('click', this.linkToSlide.bind(this), false),
      );
    }

    this.mobileQuery = window.matchMedia('(max-width: 749px)');

    //desktop dragable https://bit.ly/3zCGKzg
    this.mouseDown = false;
    this.mouseMove = false;
    this.startX;
    this.initialLeft;
    var velX = 0;
    var momentumID;

    this.initPages();

    this.resizeObserver = new ResizeObserver((entries) => this.initPages());
    this.resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.handleSlide.bind(this));

    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    //Drag listeners
    this.slider.addEventListener('mousemove', this.onDrag.bind(this));
    this.slider.addEventListener('mousedown', this.startDragging.bind(this));
    this.slider.addEventListener(
      'mouseup',
      this.stopDragging.bind(this),
      false,
    );
    //THIS IS CAUSING ISSUES FOR SLIDER IN SLIDER - triggers mouseup on parent slider
    this.slider.addEventListener(
      'mouseleave',
      this.handleMouseLeave.bind(this),
      false,
    );

    this.slider.classList.add('slider--loaded');
    this.velX = 0;
    this.initialized = true;
  }

  getSlideClass() {
    return '.slider__slide'; //take slider class outside constructor so it can be set within home-banner
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (this.mouseDown) return; //dont update until mouse is released

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
    //handle dot slider buttons
    this.sliderControlButtons = this.sliderControlWrapper.querySelectorAll(
      '.slider-counter__link',
    );

    if (this.sliderControlButtons.length > 0) {
      this.sliderControlButtons.forEach((link) => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      var current_slide = this.sliderControlButtons[this.currentPage - 1];

      if (this.dataset.type == 'product') {
        //product slider has slides hidden depending on colour

        //determine visible
        const current_color = this.closest('.product').dataset.currentColor;

        //need to select non-color slides
        let other_colors = ['gold', 'silver', 'rose'];

        var non_color_items_selector = other_colors.map((color) => {
          return `:not([data-href*="${color}"])`;
        });

        //gold and rose gold must be different
        var dot_css =
          current_color == 'gold'
            ? `.product[data-current-color*="${current_color}"] .product-dot[data-href*="${current_color}"]:not([data-href*="rosegold"])`
            : `.product[data-current-color*="${current_color}"] .product-dot[data-href*="${current_color}"]`;

        var visible_slides = this.querySelectorAll(
          `${dot_css}, .product-dot${non_color_items_selector.join('')}`,
        );
        var visible_total = visible_slides.length;
        current_slide = visible_slides[(this.currentPage - 1) % visible_total];
      }

      current_slide?.classList.add('slider-counter__link--active');
      current_slide?.setAttribute('aria-current', true);
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (!this.prevButton) return;
    if (!this.nextButton) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  handleSlide(e) {
    e.stopImmediatePropagation();
    e.stopPropagation();

    this.update();
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    this.cancelMomentumTracking();
    this.velX = 0;

    this.slider.classList.remove('no-snap');
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  startDragging(e) {
    if (this.mobileQuery.matches) {
      //disable on mobile for slider within a slider controls
      return;
    }

    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1; //set current before drag starts
    this.mouseDown = true;
    this.startX = e.pageX - this.slider.offsetLeft;
    this.initialLeft = this.slider.scrollLeft;
    this.velX = 0;
    this.cancelMomentumTracking();
  }
  onDrag(event) {
    event.preventDefault();
    if (!this.mouseDown) {
      return;
    }

    this.slider.classList.add('dragging');
    this.slider.classList.add('no-snap');

    const x = event.pageX - this.slider.offsetLeft;
    const walk = (x - this.startX) * 1.4; //scroll-fast
    var prevScrollLeft = this.slider.scrollLeft;

    this.slider.scrollLeft = this.initialLeft - walk;
    this.velX = this.slider.scrollLeft - prevScrollLeft;
  }
  stopDragging(event) {
    if (this.mobileQuery.matches) {
      // disable on mobile for slider within a slider controls
      return;
    }
    this.mouseDown = false;

    this.beginMomentumTracking();
  }
  handleMouseLeave() {
    this.mouseDown = false;
    this.slider.classList.remove('dragging');
  }

  //https://codepen.io/loxks/details/KKpVvVW
  beginMomentumTracking() {
    this.cancelMomentumTracking();
    this.momentumID = requestAnimationFrame(this.momentumLoop.bind(this));
  }
  cancelMomentumTracking() {
    cancelAnimationFrame(this.momentumID);
  }
  momentumLoop() {
    this.slider.scrollLeft += this.velX;
    this.velX *= 0.95;
    if (Math.abs(this.velX) > 0.5) {
      this.momentumID = requestAnimationFrame(this.momentumLoop.bind(this));
    } else {
      this.slider.classList.remove('dragging'); //allow clicking of links
    }
  }

  linkToSlide(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();

    var next_slide =
      this.sliderControlLinksArray.indexOf(event.currentTarget) +
      1 -
      this.currentPage;
    var clicked_control_distance =
      this.sliderFirstItemNode.clientWidth * next_slide;
    var slideScrollPosition = this.slider.scrollLeft + clicked_control_distance;

    if (event.currentTarget.classList.contains('product-dot')) {
      var media_id = event.currentTarget.dataset.mediaId;
      var slider_thumb = this.querySelector(
        `.product__media-item[data-media-id="${media_id}"]`,
      );
      slideScrollPosition = slider_thumb.offsetLeft;
    }

    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
  }

  init() {
    super.init();
    this.enableSliderLooping = true;

    this.sliderFirstItemNode = this.slider.querySelector(this.getSlideClass());
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') {
      this.setAutoPlay();
    }
  }

  getSlideClass() {
    return '.slideshow__slide'; //take slider class outside constructor so it can be set within home-banner
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    // this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (!this.prevButton) return;
    this.prevButton.removeAttribute('disabled');

    // if (!this.sliderControlButtons.length) return;

    // this.sliderControlButtons.forEach(link => {
    //   link.classList.remove('slider-counter__link--active');
    //   link.removeAttribute('aria-current');
    // });
    // this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    // this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(this.getSlideClass()).clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

//Global to not re-enstatite multiple sliders
class GenericSlider extends SlideshowComponent {
  constructor() {
    super();
  }

  getSlideClass() {
    return '.slider__slide';
  }
}

customElements.define('generic-slider', GenericSlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.closestUpsell = this.closest('cart-upsell');
    this.preOrder = this.dataset.preorder == 'true';
    this.smallValueLimit = Number(this.dataset.smallValueLimit || 0);
    this.smallValueAddition = this.dataset.smallValueAddition;
    this.bundle = this.hasAttribute('data-bundle');
    this.addEventListener('change', this.onVariantChange);
  }

  connectedCallback() {
    this.init();
  }

  init() {
    //hide unavailable options
    this.updateOptions();
    this.updateMasterId();
    this.updateUnavailableOptions();

    //start combined listing check and cacheing
    this.checkCombinedListingCache();
  }

  async onVariantChange(e) {
    if (this.bundle) {
      //bundle products have their options matched
      //change hidden button
      let first_colour_value = this.querySelector(
        "fieldset[data-colour='true'] input:checked",
      ).value;
      let other_colours = Array.from(
        this.querySelectorAll(
          "fieldset[data-colour='true']:not(:first-of-type)",
        ),
      );

      other_colours.forEach((fieldset) => {
        var matching_option = fieldset.querySelector(
          `input[value="${first_colour_value}"]`,
        );
        if (matching_option) {
          matching_option.checked = true;
        }
      });
    }

    //handle combined listings
    //TODO cannot handle large variant
    var current_product_url = this.dataset.url;
    var new_product_url =
      e.target.tagName == 'SELECT'
        ? e.target.options[e.target.selectedIndex].dataset.productUrl
        : e.target.dataset.productUrl;

    if (new_product_url && new_product_url != current_product_url) {
      this.toggleAddButton(true, '', false); //toggle atc as user should be able to purchase as new data is being fetched

      var parent_el = this.closest('.product');
      if (parent_el) {
        //toggle class to make payment loading
        parent_el.classList.add('comb-loading');
      }

      var new_product_url = e.target.dataset.productUrl ?? '';

      const modal = this.closest('quick-add-modal');
      if (modal && typeof modal.loadContent === 'function') {
        modal.loadContent(new_product_url);
        return;
      }

      var new_data;
      var stale_data;

      //etch pieces (modal) should be 'saved'
      //replace current urls configurator markup to be used later
      var product_configurator = document.querySelector(
        '.product-configurator-modal',
      );
      if (product_configurator && window.comb_listing_cache) {
        var current_cache = window.comb_listing_cache[current_product_url];
        var configurator_section =
          product_configurator.closest('.shopify-section');

        if (configurator_section && current_cache) {
          var template_id =
            configurator_section.id.replace('shopify-section-', '') ?? '';

          var cached_section = current_cache[template_id];

          if (cached_section && template_id.length > 0) {
            current_cache[template_id] = configurator_section.outerHTML;
          }
        }
      }

      //check cache
      if (
        window.comb_listing_cache &&
        window.comb_listing_cache[new_product_url]
      ) {
        stale_data = window.comb_listing_cache[new_product_url];
      } else {
        //havent loaded new data yet so need to make direct call
        var all_data = await this.getFreshData(new_product_url);

        new_data = all_data;
        stale_data = all_data[new_product_url];

        if (stale_data) {
          if (!window.comb_listing_cache) window.comb_listing_cache = {};
          window.comb_listing_cache[new_product_url] = stale_data;
        }
      }

      var stale_fragment = document.createDocumentFragment();

      // Build fragment with all sections
      for (let [key, value] of Object.entries(stale_data)) {
        this.replaceSection({
          key,
          html_text: value,
          fragment: stale_fragment,
        });
      }

      // Only replace if we have content in the fragment
      if (stale_fragment.children.length > 0) {
        document.querySelector('#MainContent').replaceChildren(stale_fragment);
      }

      //get new data
      if (!new_data) {
        new_data = await this.getFreshData(new_product_url, true);
      }

      var section_id = this.dataset.originalSection ?? this.dataset.section;

      var product_html_string = new_data[new_product_url][section_id]; //send back an object because of cache
      var fresh_product_html = new DOMParser().parseFromString(
        product_html_string,
        'text/html',
      );

      // Get a direct reference to the new container element
      const new_info_container = fresh_product_html.querySelector(
        '.product__info-container',
      );

      if (!new_info_container) return;

      if (!this.closest('.quick-add-modal__content')) {
        this.setWindowState(new_info_container, new_product_url);
      }

      // remove loading class
      var loading_parent = document.querySelector('.comb-loading');
      if (loading_parent) {
        loading_parent.classList.remove('comb-loading');
      }

      //must be document because this has been replaced
      const productEl = document.querySelector('.product');
      if (productEl) {
        //handle wrapping
        const wrapping_selector = 'wrapping-toggle';
        const wrapping_input_selector = '[name="properties[_wrapping]"]';

        var current_wrapping_el = productEl.querySelector(wrapping_selector);
        var current_wrapping_input = productEl.querySelector(
          wrapping_input_selector,
        );

        //handle pdpcapp
        const pdp_opener_selector = '[data-modal="#PopupModal-capp';
        const current_pdp_el = productEl.querySelector(pdp_opener_selector);

        const infoContainer = productEl.querySelector(
          '.product__info-container',
        );

        if (current_wrapping_el && current_wrapping_input) {
          //user has picked an option, replace wrapping el and add input (wont have one)

          var new_wrapping_el =
            new_info_container.querySelector(wrapping_selector);
          var new_product_forms = new_info_container.querySelectorAll(
            '.product product-form form, .sticky-atc product-form form',
          );

          if (new_wrapping_el) {
            new_wrapping_el.replaceWith(current_wrapping_el);
          }

          if (new_product_forms[0]) {
            Array.from(new_product_forms).forEach((el) => {
              el.appendChild(current_wrapping_input);
            });
          }
        }

        if (current_pdp_el) {
          var new_pdp_modal =
            new_info_container.querySelector('#PopupModal-capp');

          if (new_pdp_modal) {
            //current does not contain modal-dialog, so wont attach 2
            new_pdp_modal.remove();
          }
        }

        if (infoContainer) {
          infoContainer.replaceWith(new_info_container);
        }
      }

      this.reinitApps(productEl);
      return;
    }

    this.updateOptions();
    this.updateMasterId();
    this.updateUnavailableOptions();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateColorValue();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateProductUpsell();
      this.updateAfterpay();
      this.updatePayPal();
      this.updatePayInFour();
    }

    if (!this.closestUpsell && !this.closest('quick-add-modal')) {
      document.body.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            currentVariant: this.currentVariant,
            variantData: this.variantData,
          },
        }),
      );
    }

    if (this.closestUpsell) {
      this.closestUpsell.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            currentVariant: this.currentVariant,
          },
        }),
      );
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  checkCombinedListingCache() {
    if (window.comb_listing_cache) return;

    var comb_listing_product_inputs = this.querySelectorAll(
      "input:not([data-product-url=''])",
    );

    var comb_listing_urls = Array.from(comb_listing_product_inputs).map(
      (el) => el.dataset.productUrl,
    );

    if (comb_listing_urls.length == 0) return;

    //loop through and get long lasting data (images, price, name)
    //array of promises?

    Promise.all(comb_listing_urls.map((url) => this.getFreshData(url))).then(
      (data) => {
        //save to window object to not have refect when replaced WC and only last one page visit
        var data_obj = {};

        for (let i = 0; i < data.length; i++) {
          const fetch_response = data[i];

          data_obj = { ...data_obj, ...fetch_response };
        }

        window.comb_listing_cache = data_obj;
      },
    );
  }

  reinitApps(container_el) {
    //reset etch

    // The stale HTML for the new product may have been pre-fetched with the
    // current product's option_values, which don't match the new product's
    // variants.  Liquid then renders selected_or_first_available_variant.id
    // as empty.  Fix by reading the correct variant from the freshly-connected
    // VariantSelects/VariantRadios — updateMasterId() runs synchronously in
    // connectedCallback so currentVariant is available here.
    const configuratorVariantInput = document.querySelector(
      '#configurator_variant_select',
    );
    const variantSelects = container_el.querySelector(
      'variant-selects, variant-radios',
    );

    if (configuratorVariantInput && !configuratorVariantInput.value) {
      const correctId = variantSelects?.currentVariant?.id;
      if (correctId) configuratorVariantInput.value = String(correctId);
    }

    if (!this.closestUpsell && !this.closest('quick-add-modal')) {
      document.body.dispatchEvent(
        new CustomEvent('variantChange', {
          detail: {
            currentVariant: variantSelects?.currentVariant,
          },
        }),
      );
    }
    // After replaceChildren all custom element constructors and
    // connectedCallbacks have fired synchronously.  Dispatch monogramChanged
    // so configurator-modal restores its saved state and re-renders canvases.
    document.dispatchEvent(new CustomEvent('monogramChanged', {}));

    //reset yotpo
    if (
      typeof yotpoWidgetsContainer !== 'undefined' &&
      typeof yotpoWidgetsContainer.initWidgets !== 'undefined'
    ) {
      yotpoWidgetsContainer.initWidgets();
    }

    //reset ppr
    if (typeof window.pplr_Loaded !== 'undefined') {
      window.pplr_Loaded = false;
    }
    window.pplr_el = null;
    var app_container = this.querySelector('.product-personalizer');

    if (app_container) {
      app_container.innerHTML = '';
    }
    var ppr_container = container_el.querySelector('.product-personalizer');
    if (!ppr_container) return;

    if (typeof pplr_Ready === 'function') {
      pplr_Ready();
    }
    window.setTimeout(() => {
      var atc = container_el.querySelector('.product-form__submit');

      if (ppr_container && atc) {
        atc.classList.add('p_a_t_c');
      }
    }, 1);
  }

  async getFreshData(new_product_url, only_product = false) {
    const params = this.getElementParams(this);
    const url = `${new_product_url}${params}`;

    return fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const responseJson = {};

        if (only_product) {
          const sectionId =
            this.dataset.originalSection ?? this.dataset.section;
          const sectionElement = html.getElementById(
            `shopify-section-${sectionId}`,
          );
          if (sectionElement) {
            responseJson[sectionId] = sectionElement.outerHTML;
          }
        } else {
          const all_sections = html.querySelectorAll('main .shopify-section');
          all_sections.forEach((section) => {
            const sectionId = section.id.replace('shopify-section-', '');
            responseJson[sectionId] = section.outerHTML;
          });
        }

        return { [new_product_url]: responseJson };
      });
  }

  getElementParams(containing_el) {
    var radions = containing_el.querySelectorAll('input[type="radio"]:checked');
    var selected_options = Array.from(
      containing_el.querySelectorAll('input[type="radio"]:checked'),
    ).map(({ dataset }) => dataset.optionId);

    const params =
      selected_options.length > 0
        ? `?option_values=${selected_options.join(',')}`
        : '?';

    return params;
  }

  setWindowState(html, product_url) {
    //need to get new params here as the buttons have been replaced
    var new_params = this.getElementParams(html);
    window.history.pushState(
      {
        path: `${product_url}${new_params}`,
        params: new_params,
      },
      '',
      `${product_url}${new_params}`,
    );
  }

  replaceSection({ key, html_text, fragment }) {
    const html = new DOMParser().parseFromString(html_text, 'text/html');
    var section_id = `#shopify-section-${key}`;
    const current_el = document.querySelector(section_id);

    if (!current_el) return;

    var product_section_id = this.dataset.section;

    if (product_section_id == key) {
      //is product
      //only change images and title

      var current_product_el = document.querySelector(section_id);
      var current_clone = current_product_el.cloneNode(true);

      //replace new sections
      const CLASS_TO_REPLACE = [
        '.product__media-wrapper .product__media-list',
        '.product__title',
        'variant-radios script, variant-selects script',
      ];

      CLASS_TO_REPLACE.forEach((class_string) => {
        var new_section = html.querySelector(class_string);
        var current_section = current_clone.querySelector(class_string);

        if (new_section && current_section) {
          var cloned_new_section = new_section.cloneNode(true);
          current_section.parentNode.replaceChild(
            cloned_new_section,
            current_section,
          );
        }
      });
      fragment.appendChild(current_clone);
    } else {
      var new_section = html.querySelector(section_id);
      if (new_section) {
        const cloned_section = new_section.cloneNode(true);
        fragment.appendChild(cloned_section);
      }
    }
  }

  //used to only replace contnetn (doesnt change much) product data
  replaceNonCriticalProductData(new_html) {
    const CLASS_TO_REPLACE = [
      '.product__media-wrapper .product__media-list',
      '.product__title',
    ];

    CLASS_TO_REPLACE.forEach((class_string) => {
      var current_el = document.querySelector(class_string);
      var new_el = new_html.querySelector(class_string);

      if (new_el && current_el) {
        var cloned_el = new_el.cloneNode(true);
        current_el.parentNode.insertBefore(cloned_el, current_el);
        current_el.remove();
      }
    });
  }

  replaceCriticalProductData(new_html) {
    const CLASS_TO_REPLACE = ['variant-radios'];

    CLASS_TO_REPLACE.forEach((class_string) => {
      var current_el = document.querySelector(class_string);
      var new_el = new_html.querySelector(class_string);

      if (new_el && current_el) {
        var cloned_el = new_el.cloneNode(true);
        current_el.parentNode.insertBefore(cloned_el, current_el);
        current_el.remove();
      }
    });

    return;
  }

  updateUnavailableOptions() {
    if (
      !this.currentVariant ||
      !this.variantData ||
      this.hasAttribute('data-replen') ||
      this.bundle
    )
      return;

    const allOptions = this.querySelectorAll('input[type="radio"]');

    const selectedOptions = Array.from(allOptions)
      .filter((input) => input.checked)
      .map((input) => input.value);

    allOptions.forEach((option_el) => {
      const optionValue = option_el.value;
      const optionIndex = parseInt(option_el.dataset.index, 10); // Assuming you have a data-index attribute on your inputs

      var current_product_url = this.dataset.url;
      var new_product_url = option_el.dataset.productUrl;

      if (new_product_url && new_product_url != current_product_url) {
        //is a combined listing product, make sure option is true
        option_el.disabled = false;
      } else {
        // Create a potential selection by replacing the current option at its index with the one we are checking
        const potentialSelection = [...selectedOptions];
        potentialSelection[optionIndex] = optionValue;

        // Check if any variant matches this potential selection
        const isAvailable = this.variantData.some((variant) => {
          if (!variant.available) return false;

          // For subsequent options, check if the preceding selections match
          let precedingOptionsMatch = true;
          for (let i = 0; i < optionIndex; i++) {
            if (variant.options[i] !== selectedOptions[i]) {
              precedingOptionsMatch = false;
              break;
            }
          }
          return (
            precedingOptionsMatch &&
            variant.options[optionIndex] === optionValue
          );
        });

        option_el.disabled = !isAvailable;
      }
    });
  }

  handleize = (str) =>
    str
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .replace('pre-order-', '');

  updateColorValue() {
    //set the top product container color value. uses css to hide/show slides that contain value
    let product_form = this.closest(
      `#ProductContainer-${this.dataset.section}`,
    );

    if (!product_form) return;

    this.currentVariant.options.forEach((option_value, index) => {
      // handleize option
      var value = this.handleize(option_value);
      var attribute_value = `data-option-${index}`;
      if (product_form.getAttribute(attribute_value)) {
        if (value.length <= this.smallValueLimit) {
          value = value + this.smallValueAddition;
        }
        product_form.setAttribute(attribute_value, value);
      }
    });

    //update slider (for dots)
    const product_el = this.closest('.product');
    const product_slider = product_el?.querySelector('slider-component');

    if (!product_slider) return;

    product_slider.update();
  }

  updateMedia() {
    //highlight featured image
    var featured_media_id = this.currentVariant.featured_media?.id;
    if (!featured_media_id) return;
    var feature_image = document.querySelector(
      `.product__media-item[data-media-id*="${featured_media_id}"]`,
    );
    if (feature_image) {
      //highlight featured image
      const mobile_query = window.matchMedia('(max-width: 749px)');

      if (mobile_query.matches) {
        //mobile scroll into view
        var gallery_slider = document.querySelector(
          '[id^="GalleryViewer"] .slider',
        );
        // var matching_slider_control = gallery_slider.querySelector(`.slider-counter__link`)

        gallery_slider.scrollTo({
          left: feature_image.offsetLeft,
        });
      } else {
        //desktop set order
        var current_featured_image = document.querySelector(
          '.product__media-item.featured',
        );
        current_featured_image?.classList.remove('featured');

        feature_image.classList.add('featured');
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      //if a product upsell is selected, use items array style
      const input =
        productForm.querySelector('input[name="id"]') ||
        productForm.querySelector('input[name="items[0][id]"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    var current_location =
      document.querySelector('main')?.dataset.location ?? 'en';
    var current_currency =
      document.querySelector('main')?.dataset.currency ?? 'AUD';

    var money = new Intl.NumberFormat(current_location, {
      style: 'currency',
      currency: current_currency,
      currencyDisplay: 'narrowSymbol',
    });

    var on_sale = false;
    var available = this.currentVariant.available;

    const price_cents = this.currentVariant.price;
    const compare_cents = this.currentVariant.compare_at_price;

    if (compare_cents && compare_cents > price_cents) {
      on_sale = true;
    }

    const price_container = document.getElementById(
      `price-${this.dataset.section}`,
    );

    if (!price_container) return;

    const price_els = price_container.querySelectorAll(
      '.price__regular .price-item.price-item--regular, .price__sale .price-item.price-item--sale',
    );
    const compare_el = price_container.querySelector(
      '.price__sale .price-item.price-item--regular',
    );

    if (price_els.length > 0) {
      price_els.forEach((el) => {
        el.innerHTML = money.format(price_cents / 100);
      });
    }

    if (compare_el && compare_cents) {
      compare_el.innerHTML = money.format(compare_cents / 100);
    }

    const price_wrapper = price_container.querySelector('.price'); //used to show sale and OOS

    if (price_wrapper) {
      price_wrapper.classList.remove('price--sold-out');
      price_wrapper.classList.remove('price--on-sale');

      if (!available) {
        price_wrapper.classList.add('price--sold-out');
      }
      if (on_sale) {
        price_wrapper.classList.add('price--on-sale');
      }
    }

    this.inventoryScarcity(price_container);

    if (price_container) price_container.classList.remove('visibility-hidden');
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut,
    );
  }

  inventoryScarcity(container) {
    const scarcity_el = container.querySelector(
      '.price--scarcity [type="application/json"]',
    );
    if (!scarcity_el) return;
    this.scarcityData =
      this.scarcityData ||
      JSON.parse(
        container.querySelector('.price--scarcity [type="application/json"]')
          .textContent,
      );

    if (!this.scarcityData || !this.currentVariant) return;

    const scarcity_copy_el = container.querySelector('.price--scarcity span');
    if (!scarcity_copy_el) return;

    const variant_inventory =
      this.scarcityData.variant_inventory[this.currentVariant.id];

    if (
      variant_inventory &&
      variant_inventory.policy != 'continue' &&
      variant_inventory.management == 'shopify'
    ) {
      let scarcity_copy = '';
      //loop over limits to find lowest band, save copy
      for (let i = 0; i < this.scarcityData.limits.length; i++) {
        const limit_item = this.scarcityData.limits[i];
        if (limit_item.copy == '') continue;
        if (
          variant_inventory.quantity < limit_item.limit &&
          variant_inventory.quantity > 0
        ) {
          scarcity_copy = limit_item.copy.replace(
            '[amount]',
            variant_inventory.quantity,
          );
          break;
        }
      }
      scarcity_copy_el.innerHTML = scarcity_copy;
    }
  }

  updateProductUpsell() {
    const upsell_container = document.getElementById(
      `product-upsell--${this.dataset.section}`,
    );

    if (!upsell_container || !this.currentVariant) return;

    this.setUpsellImage(upsell_container);
  }

  setUpsellImage(container) {
    let color_index = container.dataset.colorIndex;

    if (!color_index) return;

    let current_color = this.handleize(
      this.currentVariant.options[parseInt(color_index)] ?? 'gold',
    );

    container.dataset.colorCurrent = current_color; //set this here to be used by product-upsell element

    //only change image that have variant featured media
    const upsell_items = container.querySelectorAll(
      `.product-upsell__item[data-${current_color}]`,
    );

    upsell_items.forEach((item) => {
      let variant_image = item.dataset[current_color];
      item.querySelector('img').src = variant_image;
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton =
      productForm.querySelector('#mwAddToCart') ||
      productForm.querySelector('[name="add"]');

    const wrapping_button = document.querySelector(
      `wrapping-toggle[data-section="${this.dataset.section}"] button`,
    );

    const c_app_button = document.querySelector(`pdp-capp button`);

    if (!addButton) return;

    const config_product = addButton.classList.contains('show-configurator');

    const addButtonText = addButton.querySelector('span');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');

      if (this.preOrder) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else if (text) {
        addButtonText.textContent = text;
      }

      //disable wrapping button
      if (wrapping_button) {
        wrapping_button.setAttribute('disabled', 'disabled');
      }

      if (c_app_button) {
        c_app_button.setAttribute('disabled', 'disabled');
      }
    } else {
      addButton.removeAttribute('disabled');

      if (config_product) {
        addButtonText.textContent = window.variantStrings.configurator;
      } else if (this.preOrder) {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (wrapping_button) {
        wrapping_button.removeAttribute('disabled');
      }

      if (c_app_button) {
        c_app_button.removeAttribute('disabled');
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateAfterpay() {
    const afterpay_el = document.querySelector(
      `#product-afterpay--${this.dataset.section}`,
    );

    if (!afterpay_el) return;

    let installments = afterpay_el.dataset.installments;

    var increment_price = this.currentVariant.price / parseInt(installments);

    afterpay_el.querySelector('.js-afterpay-price').innerHTML =
      Shopify.formatMoney(increment_price);
  }

  updatePayPal() {
    const pp_el = document.querySelector('[data-pp-message]');

    if (!pp_el) return;

    var price = (this.currentVariant.price / 100).toFixed(2);
    pp_el.setAttribute('data-pp-amount', price);
  }

  updatePayInFour() {
    const pay_in_four = this.closest('.product')?.querySelector('pay-in-four');
    if (!pay_in_four) return;

    pay_in_four.setAttribute('price', this.currentVariant.price);
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked,
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Variant links are used for swatches to go to corresponding products
class VariantLinks extends HTMLElement {
  constructor() {
    super();
    this.parent_container = this.closest('.product__info-container');
    this.link_products = JSON.parse(
      this.querySelector('#variant-links-data').innerText,
    );
    this.tone = this.dataset.initialTone.toLowerCase();

    this.addEventListener('change', this.onVariantLinkChange.bind(this));

    if (!this.parent_container) return;

    //get all variant-radios
    this.variant_radios =
      this.parent_container.querySelectorAll('variant-radios');

    //attach change event to all radios
    this.variant_radios.forEach((radio) => {
      radio.addEventListener('change', this.onVariantChange.bind(this));
    });

    //http://127.0.0.1:9292/products_preview?preview_key=0fedfedc985e65a6e1d12a5033c603f4
  }

  onVariantChange(event) {
    this.tone = event.target.value.toLowerCase();
  }

  onVariantLinkChange(event) {
    event.preventDefault();
    var target = event.target;
    if (!target) return;

    target.checked = false; //prevent being checked for when going history back

    var page_link = target.value;
    var product_id = target.dataset.productId;

    if (!page_link) return;

    window.location = page_link + this._getVariantParam(product_id);
  }

  // returns matching ton within link_products
  _getVariantParam(id) {
    //?variant=42870826991797
    var match_product = this.link_products.find((product) => {
      return product.id == id;
    });

    if (!match_product) return '';

    var match_variant = match_product.variants.find((variant) => {
      return variant.title.toLowerCase().includes(this.tone);
    });

    return match_variant ? `?variant=${match_variant.id}` : '';
  }
}
customElements.define('variant-links', VariantLinks);

class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.video_el = this.querySelector('video.lazy');
    if (!this.video_el) return;

    this.isLoaded = false;
    this.playPromise = null;

    this.attachIntersectionObserver();
    this.addEventListener('click', this.playVideo.bind(this));
  }

  attachIntersectionObserver() {
    const responsive = this.dataset.responsive == 'true';
    const options = {
      root: null,
      threshold: 0.5, // Reduced threshold for more reliable triggering
      rootMargin: '10px', // Add some margin for better detection
    };

    if ('IntersectionObserver' in window) {
      const lazyVideoObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && !this.isLoaded) {
              this.loadVideo(responsive);
              lazyVideoObserver.unobserve(entry.target);
            }
          });
        },
        options,
      );
      lazyVideoObserver.observe(this.video_el);
    } else {
      // Fallback for browsers without IntersectionObserver
      this.loadVideo(responsive);
    }
  }

  loadVideo(responsive) {
    if (this.isLoaded) return;

    this.loadVideoSources(responsive);
    this.video_el.load();
    this.video_el.classList.remove('lazy');
    this.video_el.classList.add('lazyloaded');
    this.isLoaded = true;

    // Always use the loadeddata event for consistent behavior
    this.video_el.addEventListener(
      'loadeddata',
      () => {
        this.attemptAutoplay();
      },
      { once: true },
    );

    // Add error handling
    this.video_el.addEventListener(
      'error',
      (e) => {
        console.error('Video failed to load:', e);
      },
      { once: true },
    );
  }

  loadVideoSources(responsive) {
    for (const videoSource of this.video_el.querySelectorAll('source')) {
      if (responsive) {
        const mobile_query = window.matchMedia('(max-width: 749px)');
        if (mobile_query.matches && videoSource.dataset.mobile) {
          videoSource.src = videoSource.dataset.src;
        } else if (!mobile_query.matches && videoSource.dataset.desktop) {
          videoSource.src = videoSource.dataset.src;
        }
      } else {
        videoSource.src = videoSource.dataset.src;
      }
    }
  }

  attemptAutoplay() {
    // Ensure video is muted for autoplay to work
    this.video_el.muted = true;

    // Cancel any existing play promise
    if (this.playPromise) {
      this.playPromise.catch(() => {}); // Ignore rejections
    }

    this.playPromise = this.video_el.play();

    if (this.playPromise) {
      this.playPromise
        .then(() => {
          this.video_el.classList.add('playing');
          console.log('Autoplay started successfully');
        })
        .catch((err) => {
          console.log('Autoplay blocked:', err.message);
          // Optionally show a play button or other UI indication
          this.showPlayButton();
        });
    }
  }

  showPlayButton() {
    // Optional: Add visual indication that user interaction is needed
    this.video_el.setAttribute('controls', '');
    // Or add a custom play button overlay
  }

  playVideo() {
    if (!this.isLoaded) {
      const responsive = this.dataset.responsive == 'true';
      this.loadVideo(responsive);
      return;
    }

    if (this.video_el.classList.contains('playing')) {
      this.pauseVideo();
    } else {
      this.resumeVideo();
    }
  }

  pauseVideo() {
    if (this.playPromise) {
      this.playPromise
        .then(() => {
          this.video_el.pause();
          this.video_el.classList.remove('playing');
          this.video_el.classList.add('paused');
        })
        .catch(() => {
          // Video wasn't playing, just update classes
          this.video_el.classList.remove('playing');
          this.video_el.classList.add('paused');
        });
    } else {
      this.video_el.pause();
      this.video_el.classList.remove('playing');
      this.video_el.classList.add('paused');
    }
  }

  resumeVideo() {
    this.playPromise = this.video_el.play();
    if (this.playPromise) {
      this.playPromise
        .then(() => {
          this.video_el.classList.remove('paused');
          this.video_el.classList.add('playing');
        })
        .catch((err) => {
          console.log('Play failed:', err.message);
        });
    }
  }

  // Cleanup method
  disconnectedCallback() {
    if (this.playPromise) {
      this.playPromise.catch(() => {}); // Ignore rejections
    }
  }
}

customElements.define('lazy-video', LazyVideo);
